import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const requestDemo = {
  list: (params) => {
    const url = api.requestDemo.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updateStatus: (id, payload) => {
    const url = api.requestDemo.updateStatus(id)
    return baseURL.put(url, payload, { headers: getAuthHeader() })
  }
}

export default requestDemo
